import ComposeMessages from './ComposeMessages';
import ComposeMessagesHOC from './ComposeMessagesHOC';

export default ComposeMessagesHOC(ComposeMessages);



// WEBPACK FOOTER //
// ./src/pages/ComposeMessage/index.jsx